import React, { useEffect, useState } from "react"
import { Modal, ModalBody, Button, Card, CardBody, CardText, CardTitle, Col, FormGroup, Input, Row, Spinner, Table } from "reactstrap"

import { useWallet } from "../../libs/useMetaMaskWallet"
import Web3 from "web3"

import ConnectWallet from "../../Components/ConnectWallet"
import { formatNumber } from "../../utils"
import { useToast } from "../../hooks/toast"
import { deploy } from "../Stake/utils/specialUtils"

const Special = ({}) => {
    const web3 = new Web3()
    const [isLoading, setIsLoading] = useState(false)
    const [processing, setProcessing] = useState(false)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [contractDetails, setContractDetails] = useState({ name: "", symbol: "", totalSupply: 0 })

    const toast = useToast()
    const wallet = useWallet()
    const swdtknAbiJson = require("../../abi/SWDTKN.json")
    const swdtknAbi = swdtknAbiJson.abi

    const handleDeploy = async () => {
        web3.setProvider(wallet.ethereum.provider)
        deploy(wallet.account, web3)
    }

    const setMessage = async (type, message) => {
        switch (type) {
            case "success":
                toast.addSuccess(message)
                break
            case "error":
                toast.addError(message)
                break
            case "info":
                toast.addInfo(message)
                break
            default:
                break
        }
    }

    const updateConnection = () => {
        const x = wallet.status === "connected"
        setIsConnectedToWallet(x)
        return x
    }

    return (
        <React.Fragment>
            <div className="content staking-page">
                <div className="staking-body">
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <p>Click the button to deploy</p>
                                    <Button
                                        className="btn submit-btn w-100 orange-btn text-uppercase"
                                        onClick={() => handleDeploy()}
                                        style={{ width: "100%" }}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}
export default Special
